<template>

  <card title="Leads" :subtitle="subtitle">
    <div>
      <Leads-Table/>
    </div>
    <!-- <div slot="footer" class="stats">
      <i class="far fa-clock"/> This Month
    </div> -->
  </card>
  
</template>

<script>
export default {
  name: 'Leads-Card',
  computed: {
    subtitle () {
      return ''
    }
  }
}
</script>

<style>

</style>
